export class EngineTimingData {
    getTemplateNanos: number = 0;
    getTemplateCount: number = 0;
    jsonMergeNanos: number = 0;
    jsonMergeCount: number = 0;
    slotProcessNanos: number = 0;
    slotProcessCount: number = 0;
    placeholderProcessNanos: number = 0;
    placeholderProcessCount: number = 0;
    dynamicDataNanos: number = 0;
    dynamicDataCount: number = 0;
    dynamicViewNanos: number = 0;
    dynamicViewCount: number = 0;
    dynamicActionNanos: number = 0;
    dynamicActionCount: number = 0;
    dynamicClientDataNanos: number = 0;
    dynamicClientDataCount: number = 0;

    constructor() {}
}
